import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowTriangleTop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-triangle-top"><path d="M19.25 19.25H4.75L12 4.75L19.25 19.25Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowTriangleTop;
